function isOn(value: string | undefined): boolean {
  return value === 'true' || value === '1';
}

export function isDiagnosticEnabled(): boolean {
  return isOn(import.meta.env['VITE_DIAGNOSTIC_ENABLED']) || import.meta.env.VITE_STAGE !== 'prd';
}

export function isReportsEnabled(): boolean {
  return isOn(import.meta.env['VITE_REPORTS_ENABLED']);
}

export function agentEmbedUrl(): string | null {
  return import.meta.env.VITE_AGENT_EMBED_URL || null;
}
